import Logo from 'src/assets/logo/tellet-logo-main.svg';
import { NavLink, useLocation } from 'react-router-dom';
import {
  IconUsers,
  IconBuilding,
  IconComponents,
  IconChartPie,
  IconLayoutDashboard,
  IconLogout,
} from '@tabler/icons-react';
import Image from '../atoms/Image';
import Routes from '@/router/routes';
import { cn } from '@/lib/utils';
import { Button } from '../ui/button';
import SignOutUser from '@/utils/signOutUser';

const sidebarLinks = [
  {
    _id: 1,
    name: 'Dashboard',
    icon: <IconLayoutDashboard size={18} />,
    path: Routes.super_admin_dashboard.path,
  },
  {
    _id: 2,
    name: 'Organizations',
    icon: <IconBuilding size={18} />,
    path: Routes.super_admin_dashboard_organizations.path,
  },
  {
    _id: 3,
    name: 'Users',
    icon: <IconUsers size={18} />,
    path: Routes.super_admin_dashboard_users.path,
  },
  {
    _id: 4,
    name: 'Tellets',
    icon: <IconComponents size={18} />,
    path: Routes.super_admin_dashboard_tellets.path,
  },
  {
    _id: 5,
    name: 'Prompts',
    icon: <IconChartPie size={18} />,
    path: Routes.super_admin_dashboard_prompts.path,
  },
];

function SuperAdminSidebar() {
  const location = useLocation();

  return (
    <aside
      className="h-full transition-all ease-in fixed top-0 bottom-0
        left-0 z-50 bg-white duration-200 overflow-y-auto min-h-screen border-r p-4 pt-7 max-w-[250px] w-full"
    >
      <div className="flex flex-col justify-between w-full h-full">
        <div className="relative flex flex-col w-auto h-full">
          {/* logo */}
          <div className="flex items-center justify-between w-full mb-7">
            <NavLink to={Routes.super_admin_dashboard.path} className="w-full h-10">
              <Image src={Logo} alt="logo" width={90} height={40} />
            </NavLink>
          </div>

          <div className="flex flex-col">
            {/* menu items */}
            <div className="flex flex-col w-full gap-2 mt-3">
              <ul className="flex flex-col w-full gap-1">
                {sidebarLinks?.map((item) => (
                  <NavLink
                    key={item._id}
                    to={item.path}
                    rel="preload"
                    className="flex items-center justify-center w-full h-full"
                  >
                    <li
                      className={cn(
                        'text-sm transition-all ease-in-out w-full whitespace-nowrap gap-3 flex items-center pl-3 rounded-md min-h-[40px]',
                        location.pathname === item.path
                          ? 'bg-primary text-white'
                          : 'bg-white text-dark-text whitespace-nowrap transition-all ease-in-out hover:bg-secondary/20 hover:text-primary',
                        location.pathname.includes(item.path) &&
                          item.path !== Routes.super_admin_dashboard.path &&
                          '!bg-primary !text-white',
                      )}
                    >
                      <p className="flex items-center w-full h-full gap-2">
                        {item.icon}
                        {item.name}
                      </p>
                    </li>
                  </NavLink>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <Button
          onClick={SignOutUser()}
          className="flex items-center h-8 gap-1 mx-auto text-sm font-semibold"
        >
          <IconLogout size={18} />
          Sign out
        </Button>
      </div>
    </aside>
  );
}

export default SuperAdminSidebar;
